/**
 * Generic method for retreiving the string value of an enum key.
 * @param enumDef enum Type
 * @param value key value
 * @returns string value
 */
export function getEnumValueByKey<E>(enumDef: Record<string, E>, keyValue: string | undefined) {
	const enumKeyAsString = Object.entries(enumDef).find(([key]) => key === keyValue)?.[1];
	return enumKeyAsString ? String(enumKeyAsString) : undefined;
}

/**
 * Generic method for retreiving the enum type of given string should it be valid
 * @param enumDef enum Type
 * @param keyValue key value as string
 * @returns enum value
 */
export function getEnumEntryByString<E, K extends string>(enumDef: Record<K, E>, keyValue: string | undefined) {
	const enumKeyAsString = Object.entries(enumDef).find(([key]) => key === keyValue)?.[0];
	return enumKeyAsString ? enumDef[enumKeyAsString as K] : undefined;
}
